// The four ride slots are ordinary, server-owned seats at one walkable boarding point. This orbit is only what
// clients draw; it never changes a peer's position or the movement / hearing rules.
export const CAROUSEL_PERIOD = 16000;
export const isCarouselSeat = (s) => s?.kind === 'carousel' && s.group === 'carousel' && /^carousel-[1-4]$/.test(s.id);
export function carouselPose(s, serverTime) {
  const slot = +s.id.slice(-1) - 1, a = ((serverTime % CAROUSEL_PERIOD) / CAROUSEL_PERIOD + slot / 4) * Math.PI * 2;
  const fx = s.fx + Math.cos(a) * 1.4, fy = s.fy - 1.35 + Math.sin(a) * 0.55;
  const dir16 = (Math.round((Math.atan2(-Math.sin(a), Math.cos(a)) / (Math.PI * 2)) * 16) + 16) % 16;
  return { fx, fy, x: fx - 0.5, y: fy - 0.8, dir16 };
}
